import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, FacebookIcon, InstagramIcon, YoutubeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-950 text-white/70" data-id="element-155">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-16 pb-8" data-id="element-156">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12" data-id="element-157">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1" data-id="element-158">
            <div className="mb-4" data-id="element-159">
              <img src="https://cdn.magicpatterns.com/uploads/63qskYt7Y9VwXpzp85HiTx/NTA-Colleyville-Taekwondo.webp" alt="NTA Taekwondo — Colleyville, TX" className="h-16 w-auto brightness-0 invert" data-id="element-160" />
            </div>
            <p className="text-sm leading-relaxed max-w-xs" data-id="element-161">
              A martial arts academy for Colleyville-area families. Building
              confidence, discipline, and community since 2008.
            </p>
            <div className="mt-5 space-y-2" data-id="element-162">
              <div className="flex items-start gap-2 text-sm" data-id="element-163">
                <MapPinIcon className="w-4 h-4 text-amber/60 mt-0.5 shrink-0" data-id="element-164" />
                <span data-id="element-165">750 Grapevine Hwy, Hurst, TX 76054</span>
              </div>
              <a href="tel:817-581-1419" className="flex items-center gap-2 text-sm hover:text-white transition-colors" data-id="element-166">
                <PhoneIcon className="w-4 h-4 text-amber/60" data-id="element-167" />
                817-581-1419
              </a>
              <a href="mailto:ntacolleyville@gmail.com" className="flex items-center gap-2 text-sm hover:text-white transition-colors" data-id="element-168">
                <MailIcon className="w-4 h-4 text-amber/60" data-id="element-169" />
                ntacolleyville@gmail.com
              </a>
            </div>
            {/* Social icons */}
            <div className="mt-5 flex items-center gap-4" data-id="element-170">
              <a href="#" aria-label="Facebook" className="text-white/40 hover:text-white transition-colors" data-id="element-171">
                <FacebookIcon className="w-5 h-5" data-id="element-172" />
              </a>
              <a href="#" aria-label="Instagram" className="text-white/40 hover:text-white transition-colors" data-id="element-173">
                <InstagramIcon className="w-5 h-5" data-id="element-174" />
              </a>
              <a href="#" aria-label="YouTube" className="text-white/40 hover:text-white transition-colors" data-id="element-175">
                <YoutubeIcon className="w-5 h-5" data-id="element-176" />
              </a>
            </div>
          </div>

          {/* Programs */}
          <div data-id="element-177">
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4" data-id="element-178">
              Programs
            </h3>
            <ul className="space-y-3" data-id="element-179">
              <li data-id="element-180">
                <a href="#programs" className="text-sm hover:text-white transition-colors" data-id="element-181">
                  Early Skillz (Ages 3–4)
                </a>
              </li>
              <li data-id="element-182">
                <a href="#programs" className="text-sm hover:text-white transition-colors" data-id="element-183">
                  Basic Skillz (Ages 5–6)
                </a>
              </li>
              <li data-id="element-184">
                <a href="#programs" className="text-sm hover:text-white transition-colors" data-id="element-185">
                  Core Skillz (Ages 7–9)
                </a>
              </li>
              <li data-id="element-186">
                <a href="#programs" className="text-sm hover:text-white transition-colors" data-id="element-187">
                  Teen &amp; Adult (Ages 10+)
                </a>
              </li>
              <li data-id="element-188">
                <a href="#programs" className="text-sm hover:text-white transition-colors" data-id="element-189">
                  Spectrum Skillz
                </a>
              </li>
              <li data-id="element-190">
                <a href="/birthday-parties" className="text-sm hover:text-white transition-colors" data-id="element-191">
                  Birthday Parties
                </a>
              </li>
              <li data-id="element-192">
                <a href="#" className="text-sm hover:text-white transition-colors" data-id="element-193">
                  After School
                </a>
              </li>
              <li data-id="element-194">
                <a href="#" className="text-sm hover:text-white transition-colors" data-id="element-195">
                  Summer Camp
                </a>
              </li>
            </ul>
          </div>

          {/* Academy */}
          <div data-id="element-196">
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4" data-id="element-197">
              Academy
            </h3>
            <ul className="space-y-3" data-id="element-198">
              <li data-id="element-199">
                <a href="#about" className="text-sm hover:text-white transition-colors" data-id="element-200">
                  About NTA
                </a>
              </li>
              <li data-id="element-201">
                <a href="#location" className="text-sm hover:text-white transition-colors" data-id="element-202">
                  Location &amp; Hours
                </a>
              </li>
              <li data-id="element-203">
                <a href="#cta" className="text-sm hover:text-white transition-colors" data-id="element-204">
                  Free Trial Week
                </a>
              </li>
              <li data-id="element-205">
                <a href="#cta" className="text-sm hover:text-white transition-colors" data-id="element-206">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div data-id="element-207">
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4" data-id="element-208">
              Connect
            </h3>
            <ul className="space-y-3" data-id="element-209">
              <li data-id="element-210">
                <a href="#" className="flex items-center gap-2 text-sm hover:text-white transition-colors" data-id="element-211">
                  <FacebookIcon className="w-4 h-4" data-id="element-212" />
                  Facebook
                </a>
              </li>
              <li data-id="element-213">
                <a href="#" className="flex items-center gap-2 text-sm hover:text-white transition-colors" data-id="element-214">
                  <InstagramIcon className="w-4 h-4" data-id="element-215" />
                  Instagram
                </a>
              </li>
              <li data-id="element-216">
                <a href="#" className="flex items-center gap-2 text-sm hover:text-white transition-colors" data-id="element-217">
                  <YoutubeIcon className="w-4 h-4" data-id="element-218" />
                  YouTube
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-219">
          <p className="text-xs text-white/40" data-id="element-220">
            &copy; {new Date().getFullYear()} NTA Taekwondo. All rights
            reserved.
          </p>
          <p className="text-xs text-white/40" data-id="element-221">
            Serving Hurst, Colleyville, Bedford, Euless &amp; North Richland
            Hills since 2008
          </p>
        </div>
      </div>
    </footer>;
}